<template>
    <div class="layer-overlay overlay-dark-8" style="background-image: url(&quot;images/pattern/pt19.jpg&quot;); background-repeat: repeat; background-size: auto;">
            <h2 class="h2-resultados mt-0 line-height-1 resultados-title">
          REDES SOCIALES
        </h2>
        <div class="container">           
            <div class="row redes-div">
            <div class="col-md-3">
            <a href="https://www.facebook.com/profile.php?id=100068426351096&locale=es_LA">    
                <img src="@/assets/facebook-poa-01.svg"><br/><h3>@CLUB_POA</h3>
            </a>
            </div>
            <div class="col-md-3">
            <a href="https://www.instagram.com/club_poa/?hl=es">
                <img src="@/assets/instagram-poa-01.svg"><br/><h3>@CLUB_POA</h3>
            </a> 
            </div>
            <div class="col-md-3">
            <a href="https://www.youtube.com/@clubpoa1934">
                <img src="@/assets/youtube-poa-01.svg"><br/><h3>@CLUB_POA</h3>
            </a>
            </div>
            <div class="col-md-3">
            <a href="mailto:poa@clubpoa.com.ar"> 
                <img src="@/assets/gmail-poa-01.svg"><br/><h3>@CLUB_POA</h3>
            </a>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

}


</script>
<style scoped>

.layer-overlay {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 6em 0;
}

@media screen and (min-width: 200px) {

    h2 {
    color: #5a5a5a !important;
    text-align: center;
    top: 300px;
    z-index: 10000000;
    position: absolute;
    top: 120px;
    font-size: 2.4em;
}

.col-md-3 {
    text-align: center;
    margin-bottom: 60px;
}

.container {
    padding: 6em;
}

.redes-div {
    margin-top: 60px;
}

.redes-div img {
    max-width: 80px;
    text-align: center;
}


}


@media screen and (min-width: 990px) {

    h2 {
    color: #5a5a5a !important;
    text-align: center;
    top: 300px;
     z-index: 10000000;
     position: absolute;
     top: 120px;
     font-size: 3.5em;
}

.col-md-3 {
    text-align: center;
    margin-bottom: 0px;
}

.container {
    padding: 10em;
}

.redes-div img {
    padding-top: 55px;
    max-width: 55px;
    text-align: center;
}

.redes-div {
    margin-top: 0px;
}

}







</style>